module.exports = __webpack_public_path__ + "img/cp5_02.7b7b71a2.jpg";